var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 0.666504V1.99984H10.666V3.33317H9.33268V4.6665H7.99935V3.33317H6.66602V1.99984H7.99935V0.666504H9.33268Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 8.73786C0.666016 6.06211 2.2594 3.75994 4.54625 2.72573L5.42839 3.60788C5.13007 4.26753 4.96367 5.0002 4.96367 5.77354C4.96367 8.67965 7.31954 11.0355 10.2256 11.0355C10.999 11.0355 11.7317 10.8691 12.3913 10.5708L13.2735 11.4529C12.2393 13.7398 9.93708 15.3332 7.26132 15.3332C3.61884 15.3332 0.666016 12.3804 0.666016 8.73786ZM3.69155 4.87178C2.65054 5.83352 1.99935 7.21001 1.99935 8.73786C1.99935 11.644 4.35522 13.9998 7.26132 13.9998C8.78918 13.9998 10.1657 13.3486 11.1274 12.3076C10.8324 12.348 10.5314 12.3688 10.2256 12.3688C6.58316 12.3688 3.63034 9.41603 3.63034 5.77354C3.63034 5.4678 3.65118 5.16675 3.69155 4.87178Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 3.99984V5.99984H15.3327V7.33317H13.3327V9.33317H11.9993V7.33317H9.99935V5.99984H11.9993V3.99984H13.3327Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.46ec29ffd6f82afc2865bf8a627d8099.svg";
export { ForwardRef as ReactComponent };